import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import pickingService from "../Services/pickingService";
import { LuEye } from "react-icons/lu";
import Loading from "../Modals/Loading";

const PickingList = () => {
  const [pickings, setPickings] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const loadPickings = async () => {
      try {
        setLoading(true);
        const data = await pickingService.getAll();
        setPickings(data.pickings || []);
      } catch (error) {
        console.error("Error fetching pickings:", error);
      } finally {
        setLoading(false);
      }
    };

    loadPickings();
  }, []);

  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {loading ? (
        <Loading />
      ) : (
        <div>
          <div>
            <h1 className="font-bold text-3xl text-secondary mb-4">
              Picking List
            </h1>
          </div>
          <div className="table-div">
            <table className="w-full">
              <thead className="border-y-2 text-center text-black text-[10px]">
                <tr>
                  <th className="py-3 w-[1%]">ID</th>
                  <th className="py-3 w-[4%]">Purchase ID</th>
                  <th className="py-3 w-[1%]">Supplier Invoice #</th>
                  <th className="py-3 w-[6%]">Reference</th>
                  <th className="py-3 w-[4%]">Description</th>
                  <th className="py-3 w-[4%]">Date</th>
                  <th className="py-3 w-[4%]">Status</th>
                  <th className="py-3 w-[2%]">View</th>
                </tr>
              </thead>

              <tbody>
                {pickings.map((value, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 text-[11px] text-center"
                  >
                    <td className="py-3 text-blue-500 font-bold">{value.id}</td>
                    <td className="py-3">{value.purchase}</td>

                    <td className="py-3">
                      {value.supplier_invoice_number
                        ? value.supplier_invoice_number
                        : "-"}
                    </td>

                    <td className="py-3">
                      {value.reference ? value.reference : "-"}
                    </td>

                    <td className="py-3">{value.description}</td>

                    <td className="py-3 font-semibold">
                      {moment(value.date).format("ll")}
                    </td>

                    <td className="py-3">
                      <span
                        className={`py-1 px-2 rounded-md uppercase font-semibold ${
                          value.status === "Pending"
                            ? "bg-red-500 bg-opacity-20 text-red-500"
                            : value.status === "Completed"
                              ? "bg-green-500 bg-opacity-20 text-green-500"
                              : "bg-yellow-500 bg-opacity-20 text-yellow-500"
                        }`}
                      >
                        {value.status}
                      </span>
                    </td>

                    <td className="py-3 px-2">
                      <button
                        className="rounded-md text-indigo-600 hover:text-indigo-800"
                        onClick={() => navigate(`/picking/view/${value.id}`)}
                      >
                        <LuEye className="h-4 w-4 text-sky-600" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default PickingList;
